export const TERMINAL_URL = "https://alpha.tradrquant.com/terminal";

export const OF_STATS = [
  { value: "6", unit: "timeframes", label: "1m → 1D · deep history that never resets, merged with live data" },
  { value: "LIVE", unit: "whale positions", label: "Entry, leverage, liq & PnL from tracked Hyperliquid whale wallets, on your chart" },
  { value: "30", unit: "days", label: "Stored whale-trade history behind the Big Trades strip" },
  { value: "100%", unit: "executed", label: "Order flow from real exchange prints, not estimates" },
];

export const OF_FEATURES = [
  {
    id: "footprint",
    tab: "Footprint",
    title: "See inside every candle.",
    body: "Buy × sell volume at every price row, with imbalance highlighting, point of control, delta and volume per candle on 1m, 5m and 15m.",
    points: ["Bid × Ask, Delta, Volume & Heatmap modes", "Stacked imbalances + naked POC lines", "Delta / volume / buy % per bar"],
    img: "/of/footprint.webp",
  },
  {
    id: "profile",
    tab: "Ladder & Profile",
    title: "Where the market actually traded.",
    body: "A live order-book ladder next to a VAL / POC / VAH volume profile, with liquidation zones and whale levels on the same chart.",
    points: ["Resting liquidity, grouped & sized", "Value area low / POC / value area high", "Liquidation zones + whale levels"],
    img: "/of/ladder.webp",
    alt: "/of/profile.webp",
  },
  {
    id: "tape",
    tab: "Smart Tape",
    title: "A tape that reads itself.",
    body: "Split prints are joined back into the real order, size filters cut the noise, and a speed meter shows when aggression picks up.",
    points: ["Split-print joining", "All / Large / Whale size filters", "10s aggression speed meter"],
    tape: true,
  },
  {
    id: "cvd",
    tab: "CVD",
    title: "Cumulative delta, locked to price.",
    body: "The CVD panel sits under the chart and scrolls and zooms with it. You can resize it on mobile without the page jumping.",
    points: ["Synced scroll & zoom", "Resizable on phone", "Split view: chart + order flow"],
    img: "/of/cvd.webp",
  },
  {
    id: "bigtrades",
    tab: "Big Trades",
    title: "Whale prints, plotted where they hit.",
    body: "Large bid/ask additions are plotted as bubbles on the chart, backed by 30 days of stored whale-trade history.",
    points: ["30-day whale-trade history", "Size-scaled bubbles", "Repeat prints grouped (×2, ×3)"],
    img: "/of/bigtrades.webp",
  },
  {
    id: "hyperliquid",
    tab: "Hyperliquid Layer",
    title: "The whale positions others don't show.",
    body: "Live positions from tracked Hyperliquid whale wallets, plotted with liquidation map, TP/SL marks, depth and a heatmap of resting orders.",
    points: ["Entry, leverage, liq price, PnL", "Liquidation map + TP/SL marks", "Resting-order heatmap over time"],
    img: "/of/liquidation.webp",
  },
  {
    id: "mobile",
    tab: "Fullscreen & Mobile",
    title: "A real chart on any screen.",
    body: "One tap for true fullscreen. One finger pans, pinch zooms, and dragging the price scale zooms prices. Horizontal swipes move the chart and vertical swipes scroll the page.",
    points: ["True fullscreen, Esc to exit", "Pinch zoom + price-scale drag", "Gesture-locked, no bounce"],
    img: "/of/mobile.webp",
    phone: true,
  },
  {
    id: "snapshot",
    tab: "Snapshot",
    title: "Share the read, branded.",
    body: "Full-screen snapshot preview with Save PNG, Share and Copy, stamped with symbol and UTC time.",
    points: ["Save PNG / Share / Copy", "Symbol + timestamp stamped", "Clean, chrome-free export"],
    img: "/of/snapshot.webp",
  },
];

export const TIERS = [
  { row: "BTC & ETH charts, deep history 1m → 1D", guest: true, free: true },
  { row: "Footprint, Smart Tape, CVD, Big Trades", guest: "15-min delay", free: "Live" },
  { row: "Ladder, VAL / POC / VAH, liquidation zones", guest: true, free: true },
  { row: "Hyperliquid whale layer & heatmap", guest: true, free: true },
  { row: "Cloud-saved drawings, preferences & watchlist", guest: false, free: true },
  { row: "First-seat benefit at full launch", guest: false, free: true },
];
